<template>
  <div>
    <v-btn
      icon
      :title="`Listar produtos de ${descricao_pqr[props.curva_pqr.toLowerCase()]} e ${descricao_xyz[props.curva_xyz.toLowerCase()]}`"
      @click="dialog_ativo = ! dialog_ativo"
    >
      <v-icon>mdi-eye</v-icon>
    </v-btn>

    <SysDialogFullscreen v-model="dialog_ativo">
      <template #titulo.text>
        <div class="d-flex align-center">
          <span>Produtos</span>

          <v-divider vertical dark class="mx-2" />

          <span class="font-12 text-truncate">
            Curvas
            <v-icon dark small>mdi-chevron-right</v-icon>
            {{ descricao_pqr[props.curva_pqr.toLowerCase()] }}
            <v-icon dark small>mdi-chevron-right</v-icon>
            {{ descricao_xyz[props.curva_xyz.toLowerCase()] }}
          </span>
        </div>
      </template>

      <div class="pl-2 pr-1">
        <sys-data-table
          :height="altura_janela - 148"
          :item-height="45"
          :headers="cabecalhos"
          :items="lista_produtos"
          @scroll-items="buscarProximaPaginaProdutos"
        >
          <template #top>
            <div class="d-flex align-center w-full pt-3 pb-1">
              <v-icon :size="20" color="#303030">mdi-format-list-bulleted</v-icon>
              <span class="font-18 font-weight-medium ml-1 text-gray-900">Lista de Produtos</span>

              <v-spacer />

              <div class="w-450">
                <v-text-field
                  v-model="pesquisa"
                  hide-details
                  dense clearable
                  label="Pesquisar"
                  append-icon="mdi-magnify"
                  v-lazy-input:debounce="2000"
                  @input="pesquisarProduto"
                />
              </div>
            </div>
          </template>

          <template #item.filial="{ item }">
            {{ item.filial }}
            <template v-if="item.nome_fantasia">- {{ item.nome_fantasia }}</template>
          </template>
        </sys-data-table>
      </div>
    </SysDialogFullscreen>
  </div>
</template>

<script setup>
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import {descricao_pqr, descricao_xyz} from "@/components/Diagnostico/CurvasCruzadas/ParametrizacaoDeCoberturas/CoberturasCurvasPadrao.js";
import {computed, ref, watch} from "vue";
import * as req from "@/api/compras/CoberturaEsegPorLocalidade";
import store from "@/store";
import {logout} from "@/helpers";
import {useResize} from "@/helpers/Resize";

const {altura_janela} = useResize();

const props = defineProps({
  curva_pqr: String,
  curva_xyz: String,
});

const dialog_ativo= ref(false);

const quantidade_produtos_por_pagina = 200;
let todos_produtos_carregados = false;

const cabecalhos = [
  {text: 'Filial', value: 'filial'},
  {text: 'Id Produto', value: 'idproduto'},
  {text: 'Descrição Produto', value: 'descricao_produto'},
];

watch(dialog_ativo, () => {
  if (!dialog_ativo.value) return;
  buscarListaProdutosPorCurvas();
})

const lista_produtos = ref([]);
const PAGINA_ATUAL_PRODUTOS = computed(() => Math.trunc(lista_produtos.value.length / quantidade_produtos_por_pagina));
const pesquisa = ref('');

function buscarListaProdutosPorCurvas() {
  if (todos_produtos_carregados) return;

  const parametros = {
    curva_pqr: props.curva_pqr,
    curva_xyz: props.curva_xyz,
    quantidade_produtos_por_pagina,
    pagina: PAGINA_ATUAL_PRODUTOS.value + 1,
    pesquisa: pesquisa.value
  };

  store.dispatch('loading/addRequisicao',
    req.buscarListaProdutosPorCurvas(parametros)
      .then(produtos => {
        lista_produtos.value.push(...produtos);
        todos_produtos_carregados = produtos.length !== quantidade_produtos_por_pagina;
      })
      .catch(logout)
  );
}

function pesquisarProduto() {
  lista_produtos.value = [];
  todos_produtos_carregados = false;
  buscarListaProdutosPorCurvas();
}

let timer_scroll_data_table;

function buscarProximaPaginaProdutos({scrollHeight, scrollTop, offsetHeight}) {
  const callback = () => {
    if ((scrollTop + offsetHeight + 100) < scrollHeight || !(lista_produtos.value.length > 0)) return;
    buscarListaProdutosPorCurvas();
  }

  clearTimeout(timer_scroll_data_table);
  timer_scroll_data_table = setTimeout(callback, 500);
}
</script>

<style scoped>

</style>
